import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Log } from 'app/core/logging/log';
import { AppService } from 'app/services/app/app.service';
import { EventsService } from 'app/services/events/events.service';

@Component({
    selector: 'app-signup-page',
    templateUrl: './signup-page.component.html',
    styleUrls: ['./signup-page.component.scss']
})
export class SignupPageComponent implements OnInit, OnDestroy {

    mode: string = 'signin';
    
    
    constructor(
        private appService: AppService,
        private eventsService: EventsService,
        private router: Router,
        private route: ActivatedRoute) { }

    ngOnInit() {
        let pathname:string = window.location.pathname;
        if(pathname.indexOf('signin') != -1){
            this.mode = 'signin';
        }else if(pathname.indexOf('signup') != -1){
            this.mode = 'signup';
        }else if(pathname.indexOf('reset') != -1){
            this.mode = 'reset';
        }

        this.eventsService.subscribe('getProfile', result => {
            this.redirectLanging();
        });
        this.redirectLanging();
        
    }

    ngOnDestroy() {
        this.eventsService.destroy('getProfile');
    }

    redirectLanging(){
        if(this.appService.autenticado()){
            this.router.navigate(["/"]);
        }
    }

    goTo(value: string){
        Log.debug('goTo');
        this.router.navigate([value]);
    }

    callbackSignin(){
        Log.debug('callbackSignin');
        this.redirectAfterAuth();
    }

    callbackSignup(){
        Log.debug('callbackSignup');
        this.redirectAfterAuth();
    }

    private redirectAfterAuth() {
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
        if(returnUrl != null){
            Log.debug('redirectAfterAuth', {returnUrl});
            this.router.navigateByUrl(returnUrl);
            return;
        }

        this.router.navigate(["/"]);
    }

    callbackReset(){
        Log.debug('callbackReset');   
    }
    
}
